import React, { useState } from "react";
import PageHero from "../components/PageHero";
import Reveal from "../components/Reveal";
import { contact } from "../mock";
import { useToast } from "../hooks/use-toast";
import { Toaster } from "../components/ui/toaster";
import { MessageCircle, Send, Phone, Clock, ShieldCheck, Mail } from "lucide-react";
import CmsContent from "../components/CmsContent";

const Contact = () => {
  const { toast } = useToast();
  const [form, setForm] = useState({ name: "", contact: "", message: "" });

  const channels = [
    { icon: MessageCircle, label: "WhatsApp", value: "Chat instantly, ID in 2 min", href: contact.whatsapp, color: "#25D366" },
    { icon: Send, label: "Telegram", value: "@officialdaddyanna", href: contact.telegram, color: "#229ED9" },
    { icon: Phone, label: "Signal", value: contact.phone, href: contact.signal, color: "#00e5ff" },
  ];

  const submit = (e) => {
    e.preventDefault();
    if (!form.name || !form.contact) {
      toast({ title: "Please fill your name and contact", variant: "destructive" });
      return;
    }
    toast({ title: "Message ready!", description: "Redirecting you to WhatsApp to complete your request." });
    setTimeout(() => window.open(contact.whatsapp, "_blank"), 900);
    setForm({ name: "", contact: "", message: "" });
  };

  return (
    <main>
      <Toaster />
      <PageHero
        crumb="Contact"
        title="Get in"
        highlight="Touch"
        subtitle="Reach out any time — our team is online 24x7 to activate your online cricket id and resolve any query within a minute."
      />

      <section className="pb-24 relative">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-10">
            <Reveal>
              <div className="space-y-5">
                {channels.map((c) => (
                  <a
                    key={c.label}
                    href={c.href}
                    target="_blank"
                    rel="noreferrer"
                    className="card-neon rounded-2xl p-5 flex items-center gap-4"
                  >
                    <div className="h-12 w-12 grid place-items-center rounded-xl" style={{ backgroundColor: `${c.color}22`, color: c.color }}>
                      <c.icon size={24} />
                    </div>
                    <div>
                      <div className="font-display font-semibold text-white">{c.label}</div>
                      <div className="text-gray-400 text-sm">{c.value}</div>
                    </div>
                  </a>
                ))}
                <div className="rounded-2xl border border-[#00ff87]/15 bg-[#0a0a13] p-5 space-y-3">
                  <div className="flex items-center gap-3 text-gray-300"><Clock size={18} className="text-[#00ff87]" /> Available 24 hours a day, 7 days a week</div>
                  <div className="flex items-center gap-3 text-gray-300"><ShieldCheck size={18} className="text-[#00ff87]" /> 18+ Only · Play Responsibly</div>
                  <div className="flex items-center gap-3 text-gray-300"><Mail size={18} className="text-[#00ff87]" /> Response time under 60 seconds</div>
                </div>
              </div>
            </Reveal>

            <Reveal delay={120}>
              <form onSubmit={submit} className="card-neon rounded-2xl p-7 space-y-5">
                <h3 className="font-display text-xl font-bold text-white">Request your Cricket ID</h3>
                <div>
                  <label className="block text-sm text-gray-400 mb-1.5">Your Name</label>
                  <input
                    value={form.name}
                    onChange={(e) => setForm({ ...form, name: e.target.value })}
                    className="w-full rounded-lg bg-[#12131f] border border-white/10 px-4 py-3 text-white focus:border-[#00ff87] focus:outline-none transition-colors"
                    placeholder="Enter your name"
                  />
                </div>
                <div>
                  <label className="block text-sm text-gray-400 mb-1.5">WhatsApp / Phone</label>
                  <input
                    value={form.contact}
                    onChange={(e) => setForm({ ...form, contact: e.target.value })}
                    className="w-full rounded-lg bg-[#12131f] border border-white/10 px-4 py-3 text-white focus:border-[#00ff87] focus:outline-none transition-colors"
                    placeholder="Enter your number"
                  />
                </div>
                <div>
                  <label className="block text-sm text-gray-400 mb-1.5">Message (optional)</label>
                  <textarea
                    value={form.message}
                    onChange={(e) => setForm({ ...form, message: e.target.value })}
                    rows={4}
                    className="w-full rounded-lg bg-[#12131f] border border-white/10 px-4 py-3 text-white focus:border-[#00ff87] focus:outline-none transition-colors resize-none"
                    placeholder="Tell us what you need"
                  />
                </div>
                <button type="submit" className="btn-neon w-full inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-xl font-display font-semibold">
                  <MessageCircle size={20} /> Send via WhatsApp
                </button>
              </form>
            </Reveal>
          </div>
        </div>
      </section>
      <CmsContent slug="contact-us" fallbackTitle="Contact DaddyAnna | Online Cricket ID" />
    </main>
  );
};

export default Contact;
